import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../../components/Title";
import PlanningMissionService from "../../../services/PlanningMissionService";
import Message from "../../tools/Message";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { userDetailContext } from "../../../App";
import {useContext} from "react";
import Spacer from "../../../components/Spacer";
import { useNavigate, useParams } from 'react-router-dom';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Typography from '@mui/material/Typography';
import TextField from "@material-ui/core/TextField";
import TDRService from "../../../services/TDRService";
import MainContainer from "../../../components/MainContainer";
import { headerDataMission } from "../../../data/modules/mission-header"; 
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import MissionOrderService from "../../../services/MissionOrderService";
import VehicleService from "../../../services/VehicleService";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(2),
  },
}));

export default function MissionOrderAdd() {
  const navigate = useNavigate();
  const { id } = useParams();
  const missionId = id ? id : null;
   const [form,setForm]=useState({
    mission_id:missionId,
    tdr_id:"",
    agenda_id:""
   });
  const handleClose = () => {
    navigate('/mission/planning_mission'); 
  };


  function handleCloseMessage(){
    setMessage({ ...message, open: false });
    };
  const contextData = useContext(userDetailContext);
  const [rows, setRows] = useState([]);
  const [missionData, SetMissionData] = useState({});
  const [details,setDetails]=useState([]);
  const [id_to_delete, setId_to_delete] = useState(0);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'Voulez vous vraiment supprimer  ?',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const [agenda,setAgenda]=useState([]);
  const [affiche,setAffiche]=useState(false);
  const [listedestination,setListedestination]=useState([]);
  const [intervenants,setIntervenant]=useState([]);
  const [intervenantsoption,setIntervenantoption]=useState([]);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [drivers, setDrivers] = useState([]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    async function fetchMissionDetails() {
      setOpenLoadingSimpleBackdrop(true);
        try {
            const result = await PlanningMissionService.getdetails(missionId);
            if (result?.data?.length) {
                const mission = result.data[0];
                SetMissionData(mission || {});
                
                const intervenantParsed = JSON.parse(mission.intervenant || '[]');
                setIntervenant(intervenantParsed);
                setIntervenantoption(intervenantParsed.map((name) => ({ user_id: name, nom: name })));
                if (mission.agedref?.mission_planning_agenda_id) {
                    const agendaResult = await TDRService.getagendadetails(mission.agedref.mission_planning_agenda_id);
                    if (agendaResult?.data) {
                        setAffiche(true);
                        setListedestination(agendaResult.data);
                    }
                }
            } else {
                SetMissionData({});
            }
        } catch (error) {
            console.error("Error fetching mission details:", error);
        } finally {
            setOpenLoadingSimpleBackdrop(false);
        }
    }

    async function fetchAgendaSimple() {
        try {
            const result = await TDRService.getagendasimple();
            if (result?.data) {
                setAgenda(result.data.map((row) => ({ ...row, id: row.id })));
            }
        } catch (error) {
            console.error("Error fetching simple agenda:", error);
        }
    }

    async function fetchDrivers() {
      setOpenLoadingSimpleBackdrop(true);
        try {
          console.log("fetching drivers");
            const result = await VehicleService.getDriversMission();
            if (result?.data) {
              console.log(result.data);
                setDrivers(result.data);
            }
        } catch (error) {
            console.error("Error fetching drivers:", error);
        } finally {
            setOpenLoadingSimpleBackdrop(false);
        }
    }

    fetchMissionDetails();
    fetchAgendaSimple();
    fetchDrivers();
}, [missionId]);


  function handleCloseMessage(){
    setMessage({...message, open: false});
  }

  function handleChange(event, index) {
    event.preventDefault();
    const { name, value } = event.target;

    let updatedList = [...listedestination];
    if (name === "participautre") {
      updatedList[index] = {
        ...updatedList[index],
        participautre: value
      };
    }
    else  if (name === "participants") {
      updatedList[index] = {
        ...updatedList[index],
        participants: value
      };
    } else if (name === "observation") {
      updatedList[index] = {
        ...updatedList[index],
        observation: value
      };
    }

    setListedestination(updatedList);
  }
  

function handleChangeMissionary(event, value, index) {
  event.preventDefault();
  
  let updatedList = [...listedestination];
  
  updatedList[index] = {
    ...updatedList[index], 
    user_id: value 
  };

  setListedestination(updatedList);
}

function handleChangeParticipant(event, value, index) {
  event.preventDefault();
  
  let updatedList = [...listedestination];
  
  updatedList[index] = {
    ...updatedList[index], 
    particip: value 
  };

  setListedestination(updatedList);
}

const handleSubmit = async () => {
  setOpenLoadingSimpleBackdrop(true);
    console.log("OM generating");
          try {
              const response = await MissionOrderService.missionOrderGenerate();
              console.log(response);
              // Ensure the response is a blob
              const blob = await response.data;
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              a.download = `OM.pdf`; 
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          } catch (error) {
              console.error('Erreur lors du téléchargement du PDF :', error);
          }
          setOpenLoadingSimpleBackdrop(false);
  }
 

  return (
    <React.Fragment>
         <MainContainer {...headerDataMission}>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
         <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            <Paper  variant="outlined" style={{ marginTop: '20px', padding: '20px' }}>
                <Grid container spacing={2} justify="center">
                    <Title style={{ textAlign: "center",marginTop:'20px' ,backgroundColor: '#2196F3 !important',borderRadius: '4px'  }}>Préparation Ordre de Mission</Title>
                </Grid>
                <Spacer y={2} />
            
                    <Grid container spacing={2}>
                    <Grid item xs={2}>
                            <Typography variant="body1" align="left" >Ordre est donnée à :</Typography>
                            </Grid>
                            <Grid item xs={10}>
                            <Autocomplete
                              id="tags-outlined"
                              options={[...(missionData?.missionnary || []), ...intervenantsoption]} 
                              getOptionLabel={(option) => option.nom || ''} 
                              filterSelectedOptions
                              onChange={(event, value) => handleChangeMissionary(event, value)}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      fullWidth
                                      id="outlined-basic"
                                      size="small"
                                      variant="outlined"
                                      label="Sélectionnez un intervenant" 
                                  />
                              )}
                          />

                        </Grid>
                      
                        <Grid item xs={2}>
                            <Typography variant="body1" align="left" >Moyen de déplacement :</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Typography variant="body1">{missionData.transport}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="body1" align="left" >Lieu de depart :</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Typography variant="body1">{missionData.lieu}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="body1" align="left" >Objet de la mission :</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Typography variant="body1">{missionData.mission_title}</Typography>
                        </Grid>
                        {affiche&&
                          <>
                           <Grid item xs={2}>
                              <Typography variant="body1" align="left" >Détail agenda :</Typography>
                           </Grid>
                           <Grid item xs={12}> </Grid>
                          <Grid item xs={12}>
                             <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell  >Date début </TableCell>
                                                <TableCell  >Date Fin </TableCell>
                                                <TableCell  >Heure</TableCell>
                                                <TableCell >Activités</TableCell>
                                                <TableCell >Type</TableCell>
                                                <TableCell >Véhicule</TableCell>
                                                <TableCell >Chauffeur</TableCell>
                                                <TableCell >Missionnaire</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {listedestination.map((items, index) => (
                                                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                    <TableCell component="th" scope="row"  ><TextField fullWidth id="outlined-basic" size="small" label="" variant="outlined" value={formatDate(items.date_begin)} /></TableCell>
                                                    <TableCell component="th" scope="row"  ><TextField fullWidth id="outlined-basic" size="small" label="" variant="outlined" value={formatDate(items.date_begin)} /></TableCell>
                                                    <TableCell component="th" scope="row"  ><TextField fullWidth id="outlined-basic" size="small" label="" variant="outlined" value={items.heure_begin +" - "+items.heure_end } /></TableCell>
                                                    <TableCell>
                                                      <TextField fullWidth id="outlined-basic" size="small" label="" variant="outlined" value={items.libelle===null?items.depart+"-"+items.arriver:items.libelle} name="activity" /*onChange={(event) => handleChange(event, index)}*/ />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Autocomplete id="tags-outlined" 
                                                        options={ [{id:1,nom:"FID"},{id:2,nom:"Externe"}]} 
                                                        getOptionLabel={(option) => option.nom}
                                                            filterSelectedOptions
                                                            // onChange={(event, value) => handleChangeMissionary(event, value, index)}
                                                            // value={items.user_id}
                                                            renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                id="outlined-basic"
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                            )} 
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Autocomplete id="tags-outlined" 
                                                        options={ [{id:1,nom:"FID"},{id:2,nom:"Location"}]} 
                                                        getOptionLabel={(option) => option.nom}
                                                            filterSelectedOptions
                                                            // onChange={(event, value) => handleChangeMissionary(event, value, index)}
                                                            // value={items.user_id}
                                                            renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                id="outlined-basic"
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                            )} 
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Autocomplete multiple id="tags-outlined" 
                                                        options={ [...missionData.missionnary, ...intervenantsoption]} 
                                                        getOptionLabel={(option) => option.nom}
                                                            filterSelectedOptions
                                                            onChange={(event, value) => handleChangeMissionary(event, value, index)}
                                                            value={items.user_id}
                                                            renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                id="outlined-basic"
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                            )} 
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Autocomplete multiple id="tags-outlined" 
                                                        options={ [...missionData.missionnary, ...intervenantsoption]} 
                                                        getOptionLabel={(option) => option.nom}
                                                            filterSelectedOptions
                                                            onChange={(event, value) => handleChangeMissionary(event, value, index)}
                                                            value={items.user_id}
                                                            renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                id="outlined-basic"
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                            )} 
                                                        />
                                                    </TableCell>
                                                   
                                                    {missionData.categtype==="groupe"&&
                                                      <>
                                                        <TableCell>
                                                          <Autocomplete multiple id="tags-outlined" 
                                                              options={missionData.participants} 
                                                              getOptionLabel={(option) => option.nom}
                                                              filterSelectedOptions
                                                              onChange={(event, value) => handleChangeParticipant(event, value, index)}
                                                              value={items.particip}
                                                              renderInput={(params) => (
                                                              <TextField
                                                                  {...params}
                                                                  fullWidth
                                                                  id="outlined-basic"
                                                                  size="small"
                                                                  variant="outlined"
                                                              />
                                                              )} 
                                                          />
                                                       </TableCell>
                                                      </>
                                                    }
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        </Table>
                                    </TableContainer>
                            </Grid>
                          </>
                        }
                   
                          <Grid item xs={6}>
                             
                           </Grid>
                              
                          <Grid item xs={12} justifyContent="right">
                              
                              <Button variant="contained" color="secondary" style={{marginBottom:"40px"}} onClick={handleClose} autoFocus>
                                Annuler
                              </Button> 
                              <Button variant="contained" color="primary" style={{marginRight:'30px',marginBottom:"40px"}} onClick={handleSubmit} autoFocus>
                                Enregistrer
                              </Button>
                          </Grid>
                          </Grid>
                    </Paper>
         </MainContainer>
     
    </React.Fragment>
  );
}
